import styled from "@emotion/styled";
import { fontMerriweather, fontRoboto } from "@product/scmp-sdk";

import { EntityLink } from "~/components/entity-link";
import { StyledLi } from "~/components/schema-render/content/styles";

export const LiveTagContainer = styled.div`
  &:not(:empty):not(:last-child) {
    margin-block-end: 12px;
    ${props => props.theme.breakpoints.up("tablet")} {
      margin-block-end: 16px;
    }
  }
`;

export const LinkContainer = styled.div`
  :not(:empty, :last-child) {
    margin-block-end: 4px;
  }

  > :not(:first-child) {
    display: none;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
`;
export const Cover = styled.div``;
export const Content = styled.div``;
export const Footer = styled.div``;
export const StyledEntityLink = styled(EntityLink)`
  inline-size: 100%;
`;

export const Container = styled.div`
  display: grid;
  grid-template-areas:
    "cover"
    "header"
    "content"
    "footer";
  grid-template-columns: 1fr;
  &:hover {
    ${StyledEntityLink} {
      color: #2c4692;
    }
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    grid:
      "cover . header" min-content
      "cover . content" min-content
      "cover . footer" min-content
      "cover . ." min-content
      / 0.5fr 20px 0.5fr;
  }

  ${Cover} {
    grid-area: cover;

    margin-block-end: 12px;
  }

  ${Header} {
    grid-area: header;

    margin-block-end: 12px;

    font-weight: 900;
    font-size: 18px;
    font-family: ${fontMerriweather};
    line-height: 26px;

    ${props => props.theme.breakpoints.up("tablet")} {
      font-size: 22px;
      line-height: 29px;
    }
  }

  ${Content} {
    grid-area: content;

    margin-block-end: 12px;

    color: #666666;
    font-size: 16px;
    font-family: ${fontRoboto};
    line-height: 22px;

    ${StyledLi} + ${StyledLi} {
      padding-block-start: 10px;
    }

    ${props => props.theme.breakpoints.up("tablet")} {
      font-size: 14px;
      line-height: 18px;
    }
  }

  ${Footer} {
    grid-area: footer;

    color: #a1a1a1;
    font-size: 12px;
    font-family: ${fontRoboto};
  }

  ${StyledEntityLink} {
    position: relative;

    color: #000000;
  }
`;
